export default __webpack_public_path__ + "static/media/star.6453221c.png";